import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	popupStoryPointNonNegative: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	popupStoryPointNonNegative: {
		id: 'issue-field-story-point-estimate-inline-edit.story-point-estimate.tooltip-label',
		defaultMessage: "Time for some positivity. Story point estimates can't be negative.",
		description:
			'Tooltip message that will be shown when the negative story point estimate is entered',
	},
});
export default messages;
